import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getDomainAll = (domain: any): any => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_DOMAIN_ALL, {
    params: {
      SubjectId: domain.subjectId,
      DomainId: domain.domainId,
      Name: domain.name,
      OrderByColumn: domain.orderByColumn,
      SortDir: domain.sortByDesc,
      PageSize: domain.pageSize,
      PageNumber: domain.pageNumber,
      IsActive: domain.inactiveActive ? undefined : domain.isActive,
      domainId: domain.domainId,
      StateId: domain.stateId,
    },
  });
};

export const getDomainExport = (domain: any): any => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_DOMAIN_EXPORT, {
    params: {
      SubjectId: domain.subjectId,
      DomainId: domain.domainId,
      Name: domain.name,
      OrderByColumn: domain.orderByColumn,
      SortDir: domain.sortByDesc,
      PageSize: domain.pageSize,
      PageNumber: domain.pageNumber,
      IsActive: domain.isActive,
      StateId: domain.stateId,
    },
  });
};

export const postDomain = (postDomainData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_DOMAIN,
    postDomainData,
    {}
  );
};
export const updateDomain = (updateDomainData) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_DOMAIN,
    updateDomainData,
    {}
  );
};

export const deleteDomaincontent = (domainId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_DOMAIN, {
    params: {
      id: domainId,
    },
  });
};
export const getDomainState = (pageSize, pageNumber) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STATE, {
    params: {
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const getDomainGrade = (pageSize: number, pageNumber: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADE, {
    params: {
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const getDomainSubjects = (pageSize, pageNumber) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_CONTENT_AREA_ALL, {
    params: {
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const getAllDomain = (pageSize = 10, pageNumber = 1, SubjectId) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_DOMAIN_ALL, {
    params: {
      SubjectId: SubjectId,
      Name: "modern",
      OrderByColumn: "Name",
      SortDir: "Asc",
      PageSize: pageSize,
      PageNumber: pageNumber,
    },
  });
};

export const getAllDomainsBySubject = (
  subjectId,
  pageSize = 999 * 999,
  pageNumber = 1,
  isActive = true
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_DOMAIN_ALL, {
    params: {
      SubjectId: subjectId,
      OrderByColumn: "Name",
      SortDir: "Asc",
      PageSize: pageSize,
      PageNumber: pageNumber,
      IsActive: isActive,
    },
  });
};

export const getDomainById = (domainId): any => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_DOMAIN_DETAILS}/${domainId}`
  );
};
